import { motion } from "framer-motion";

/**
 * Drop-in replacement for the old IntersectionObserver Reveal.
 * Uses framer-motion's whileInView for richer, GPU-accelerated entrance.
 *
 * Props:
 *  - delay (ms) for stagger
 *  - direction "up" | "down" | "left" | "right" | "fade"
 *  - amount (intersection threshold)
 *  - as: HTML element tag
 */
export const Reveal = ({
  children,
  delay = 0,
  direction = "up",
  amount = 0.15,
  className = "",
  as = "div",
  ...rest
}) => {
  const MotionTag = motion[as] || motion.div;

  const offsets = {
    up: { y: 28, x: 0 },
    down: { y: -28, x: 0 },
    left: { x: 28, y: 0 },
    right: { x: -28, y: 0 },
    fade: { x: 0, y: 0 },
  };
  const off = offsets[direction] || offsets.up;

  return (
    <MotionTag
      initial={{ opacity: 0, ...off }}
      whileInView={{ opacity: 1, x: 0, y: 0 }}
      viewport={{ once: true, amount }}
      transition={{
        duration: 0.7,
        ease: [0.22, 1, 0.36, 1],
        delay: delay / 1000,
      }}
      className={className}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};

export default Reveal;
